module.exports = __webpack_public_path__ + "media/images/brand/lander/left-aa7ac336ca4ad17a35b6b7604fb0adfb.png";